import React, { lazy } from 'react';
import { PriceDisplay } from './PriceDisplay';
import { Check } from 'lucide-react';
export function FinalCTA() {
  const cartLink = 'https://carlosponte.com/cart/add?id=56937498575173&quantity=1';
  return <section className="py-10 md:py-20 bg-navy-900 text-white text-center content-section" data-id="element-143">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-144">
        <h2 className="font-heading text-2xl md:text-5xl font-bold text-white mb-4 md:mb-8" data-id="element-145">
          Una Vez Más,{' '}
          <span className="highlight-burgundy text-gold-100" data-id="element-146">
            Todo Lo Que Recibirás
          </span>
        </h2>

        <div className="mb-6 md:mb-10" data-id="element-147">
          <img src="https://cdn.magicpatterns.com/uploads/oBFaCE6wyFBo9U7NSP5ieD/20260225_1349_Image_Generation_simple_compose_01kjav77w8f2wrzq7hhc4dkpn4.png" alt="Biblia Visual — Paquete Completo con todos los bonos" loading="lazy" width="600" height="400" className="w-full max-w-sm md:max-w-2xl mx-auto rounded-xl shadow-2xl" data-id="element-148" />
        </div>

        <div className="flex flex-wrap justify-center gap-4 mb-6 md:mb-10 text-sm md:text-base text-gray-300" data-id="element-149">
          <span className="flex items-center" data-id="element-150">
            <Check className="w-4 h-4 text-gold-500 mr-2" data-id="element-151" />{' '}
            <span className="font-bold text-white" data-id="element-152">Acceso a Biblia Visual</span>
          </span>
          <span className="flex items-center" data-id="element-153">
            <Check className="w-4 h-4 text-gold-500 mr-2" data-id="element-154" />{' '}
            <span data-id="element-155">
              500+ páginas,{' '}
              <span className="font-bold text-gold-200" data-id="element-156">280+ imágenes HD</span>
            </span>
          </span>
          <span className="flex items-center" data-id="element-157">
            <Check className="w-4 h-4 text-gold-500 mr-2" data-id="element-158" /> Formato Digital
          </span>
          <span className="flex items-center" data-id="element-159">
            <Check className="w-4 h-4 text-gold-500 mr-2" data-id="element-160" />{' '}
            <span className="font-bold text-gold-400" data-id="element-161">
              7 Bonus Incluidos Gratis
            </span>
          </span>
          <span className="flex items-center" data-id="element-162">
            <Check className="w-4 h-4 text-gold-500 mr-2" data-id="element-163" /> Actualizaciones de
            por vida
          </span>
          <span className="flex items-center" data-id="element-164">
            <Check className="w-4 h-4 text-gold-500 mr-2" data-id="element-165" />{' '}
            <span className="underline-subtle text-white" data-id="element-166">
              Garantía de 120 días
            </span>
          </span>
        </div>

        <div className="bg-navy-800 rounded-2xl p-5 md:p-8 border border-navy-700 max-w-2xl mx-auto shadow-2xl" data-id="element-167">
          <div className="flex flex-col md:flex-row items-center justify-center gap-4 mb-4 md:mb-6" data-id="element-168">
            <div className="text-gray-400" data-id="element-169">
              <p className="text-sm uppercase tracking-wide" data-id="element-170">Valor total</p>
              <p className="text-xl line-through decoration-red-500 font-medium" data-id="element-171">
                $171.99+
              </p>
            </div>
            <div className="hidden md:block w-px h-12 bg-gray-700" data-id="element-172"></div>
            <div data-id="element-173">
              <p className="text-sm text-gold-400 uppercase font-bold tracking-wider" data-id="element-174">
                Pago único hoy
              </p>
              <PriceDisplay amount={9.99} className="text-4xl md:text-5xl font-bold text-white text-shadow-gold" showCurrencyCode={true} data-id="element-175" />
            </div>
          </div>

          <a href={cartLink} className="block w-full bg-gradient-to-r from-gold-500 to-amber-600 hover:from-gold-600 hover:to-amber-700 text-white font-bold py-4 md:py-5 px-6 rounded-lg shadow-lg hover:shadow-gold-500/30 transition-all transform hover:-translate-y-1 text-xl uppercase tracking-wide will-change-transform" data-id="element-176">
            AGREGAR AL CARRITO »
          </a>
          <p className="text-gray-400 text-sm mt-3" data-id="element-177">
            Acceso inmediato a{' '}
            <span className="font-bold text-gray-300" data-id="element-178">Biblia Visual</span> +{' '}
            <span className="font-bold text-gold-400" data-id="element-179">Todos los Bonos</span>
          </p>
        </div>
      </div>
    </section>;
}